export default __webpack_public_path__ + "static/media/TZ.a27ec628.svg";